import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import { mapToDDL, mapToObjectDDL } from "../../common/mapper";
import { DEFAULT_NEW_DATA } from "./config";
import { HttpStatus } from "../../common/Constants";
import { defaultTableChange } from "../../../modules/custom/customTable";

class MasterMekanik extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCabang: [],
      selectedCabang: null,
      dataTable: [],
      userAccess: null,
      loading: false,
      pagination: {
        limit: 5,
        page: 1,
        totalData: 0,
      },
      employeeOptions: [],
      roleOptions: [],
      error: {
        role: null,
        name: null,
      },
      isCreateData: false
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
    this.fetchDataRole();
  }

  componentDidUpdate(prevProps, prevState) {
    const currKodeCabang = this.state.selectedCabang?.value;
    const prevKodeCabang = prevState.selectedCabang?.value;

    if (prevKodeCabang !== currKodeCabang) {
      this.setState({
        pagination: {
          limit: 5,
          page: 1,
          totalData: 0,
        },
      });
      this.fetchDataEmployeeForMechanic(currKodeCabang);
      this.fetchDataTable(this.state.selectedCabang?.value, 5, 1);
    }
  }

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Master Mekanik",
      args: null,
    });
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          ),
          selectedCabang: mapToObjectDDL(
            filteredData[0].namaDealer,
            filteredData[0].kodeCabang
          ),
          userAccess: getUserAccess(
            this.props.menuAccess,
            filteredData[0].kodeCabang
          ),
        }));
      }
    }
    this.handleTriggerLoading();
  };

  fetchDataTable = async (kodeCabang, limit, page) => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterMechanic,
      menuName: "Master Mekanik",
      setError: this.props.setError,
      args: {
        kodeCabang,
        limit,
        page,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data?.map((item) => {
          const { role, employee, mechanicId } = item;
          return {
            id: item.id,
            mechanicId,
            userId: employee.userId,
            userName: employee.userName,
            mechanicName: employee.mechanicName,
            role: role.value,
            roleKey: role.key,
            isSaved: true
          };
        }),
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
    this.handleTriggerLoading();
  };

  fetchDataEmployeeForMechanic = async (kodeCabang) => {
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getEmployeeForMechanic,
      menuName: "Master Mekanik",
      setError: this.props.setError,
      args: {
        kodeCabang,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        employeeOptions: res.data.data?.map((item) => ({
          label: item.mechanicName,
          value: item.userId,
          userName: item.userName,
        })),
      }));
    }
  };

  fetchDataRole = async () => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
      setError: this.props.setError,
      menuName: "CRM Management CDB",
      args: { paramFilters: { bizparCategory: "MECHANIC_TYPE" } },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        roleOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        ),
      }));
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  handleValueChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleAddData = () => {
    this.setState((prev) => ({
      ...prev,
      dataTable: [...prev.dataTable, { ...DEFAULT_NEW_DATA }],
      isCreateData: true
    }));
  };

  handleRefresh = () => {
    this.fetchDataTable(this.state.selectedCabang?.value, this.state.pagination.limit, this.state.pagination.page);
  };

  checkError = (data) => {
    console.log(data);
    let tempError = {};
    if (!data?.role) {
      tempError.role = "Field Wajib Diisi";
    } else {
      tempError.role = null;
    }
    if (!data.mechanicName) {
      tempError.name = "Field Wajib Diisi";
    } else {
      tempError.name = null;
    }

    this.setState({ error: tempError });
    return Object.values(tempError).filter((item) => item).length > 0;
  };

  handleSave = async (index) => {
    const data = this.state.dataTable[index];
    if (this.checkError(data)) {
      return;
    }
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMechanic,
      menuName: "Master Mekanik",
      setError: this.props.setError,
      args: {
        mechanicId: data?.mechanicId,
        userId: data?.userId,
        userName: data?.userName,
        mechanicName: data?.mechanicName,
        role: data?.roleKey,
        kodeCabang: this.state.selectedCabang?.value,
      },
    });
    this.handleTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleRefresh();
    }
  };

  toggleEdit = (index, action) => {
    if (action === "save") {
      if(this.state.isCreateData){
        this.setState({isCreateData: false})
      }
      return this.handleSave(index);
    }
    this.setState((prev) => ({
      dataTable: prev.dataTable.map((item, i) =>
        i === index ? { ...item, isSaved: !item.isSaved } : item
      ),
    }));
  };

  handleDelete = async (index) => {
    if (!this.state.dataTable[index].mechanicName) {
      this.setState((prev) => ({
        ...prev,
        dataTable: prev.dataTable.filter((_, idx) => idx !== index),
      }));
    }
    this.handleTriggerLoading();
    const data = this.state.dataTable[index];
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMechanic,
      setError: this.props.setError,
      menuName: "Master Mekanik",
      args: {
        id: data.id,
      },
    });
    this.handleTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleRefresh();
    }
  };

  handleDataTableChange = (name, index, value) => {
    this.setState((prev) => ({
      ...prev,
      dataTable: prev.dataTable.map((item, i) =>
        i === index ? { ...item, [name]: value } : item
      ),
    }));
  };

  getTableConfig = () => [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          return page * rowsPerPage + tableMeta.rowIndex + 1;
        },
        setCellProps: () => ({
          style: { width: "5%" },
        }),
      },
    },
    {
      name: "userName",
      label: "Username",
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "15%" },
        }),
      },
    },
    {
      name: "mechanicName",
      label: "Nama Lengkap",
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "35%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const isSaved = this.state.dataTable[rowIndex]?.isSaved;
          if (isSaved) {
            return val;
          }

          return (
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="mechanicName"
              isClearable
              mandatory
              options={this.state.employeeOptions}
              errorMessage={this.state.error.name}
              value={mapToDDL(val, val)}
              onChange={(value, { name }) => {
                this.handleDataTableChange("userId", rowIndex, value?.value);
                this.handleDataTableChange(
                  "mechanicName",
                  rowIndex,
                  value?.label
                );
                this.handleDataTableChange(
                  "userName",
                  rowIndex,
                  value?.userName
                );
              }}
            />
          );
        },
      },
    },
    {
      name: "role",
      label: "Role",
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "30%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const data = this.state.dataTable[rowIndex];
          const isSaved = data?.isSaved;
          if (isSaved) {
            return val;
          }

          return (
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              isClearable
              mandatory
              name="role"
              errorMessage={this.state.error.role}
              options={this.state.roleOptions}
              value={mapToDDL(val, data.roleKey)}
              onChange={(value, { name }) => {
                this.handleDataTableChange(name, rowIndex, value?.label);
                this.handleDataTableChange("roleKey", rowIndex, value?.value);
              }}
            />
          );
        },
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "15%" },
        }),
        customBodyRender: (_, { rowIndex }) => {
          const isSaved = this.state.dataTable[rowIndex]?.isSaved;
          const isCanEdit = this.state.userAccess?.updateAccess;
          const isCanCreate = this.state.userAccess?.createAccess;
          const isCanDelete = this.state.userAccess?.deleteAccess;
          
          const disabledSave = this.state.isCreateData ? !isCanCreate : !isCanEdit
          return (
            <FlexView vAlignContent="center" style={{ gap: "12px" }}>
              {!isSaved ? (
                <Button
                  className="btnAct background-transparent txt-site txt-title"
                  type="button"
                  disabled={disabledSave}
                  onClick={() => this.toggleEdit(rowIndex, "save")}
                >
                  <i
                    className={`fa fa-save ${
                      disabledSave ? "color-grey" : "color-red"
                    }`}
                  />
                </Button>
              ) : (
                <Button
                  className="btnAct background-transparent txt-site txt-title"
                  type="button"
                  disabled={!isCanEdit}
                  onClick={() => this.toggleEdit(rowIndex, "toggle")}
                >
                  <i
                    className={`fa fa-pencil-alt ${
                      isCanEdit ? "color-red" : "color-grey"
                    }`}
                  />
                </Button>
              )}
              <Button
                className="btnAct background-transparent txt-site txt-title"
                type="button"
                disabled={!isCanDelete}
                onClick={() => this.handleDelete(rowIndex)}
              >
                <i
                  className={`fa fa-trash ${
                    isCanDelete ? "color-red" : "color-grey"
                  }`}
                />
              </Button>
            </FlexView>
          );
        },
      },
    },
  ];

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
    this.fetchDataTable(
      this.state.selectedCabang?.value,
      this.state.pagination.limit,
      tableState.page + 1
    );
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
    this.fetchDataTable(
      this.state.selectedCabang?.value,
      tableState.rowsPerPage,
      1
    );
  };

  render() {
    const {
      selectedCabang,
      dataCabang,
      dataTable,
      loading,
      userAccess,
      pagination,
    } = this.state;
    const tableConfig = this.getTableConfig();

    return (
      <Container>
        <FlexView
          vAlignContent="center"
          marginBottom="15px"
          style={{ gap: "15px" }}
        >
          <p className="margin margin-bottom-15px">Cabang</p>
          <SimpleDDL
            id="select_options_nama_cabang"
            box="search"
            name="selectedCabang"
            containerclassname="width width-300px"
            placeholder="Nama cabang hak akses"
            options={dataCabang}
            value={selectedCabang}
            onChange={(value, { name }) => this.handleValueChange(name, value)}
          />
        </FlexView>

        {userAccess?.createAccess && (
          <SimpleButton
            id="button_add"
            text="Tambah"
            className="margin margin-bottom-10px"
            styles={{ marginLeft: 0 }}
            onClick={this.handleAddData}
            icon={<i className="fa fa-plus" style={{ marginRight: 10 }} />}
          />
        )}

        <SimpleDataTable
          columns={tableConfig}
          data={dataTable}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage
          )}
        />
        {loading && <SimpleLoadingOverlay active={loading} />}
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterMekanik);
